import script from "./DashboardVue.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardVue.vue?vue&type=script&setup=true&lang=js"

import "./DashboardVue.vue?vue&type=style&index=0&id=1bae934c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bae934c"]])

export default __exports__